import { FC } from 'react'
import cx from 'classnames'

type TextType =
  | 'body1'
  | 'body2'
  | 'body3'
  | 'notes1'
  | 'notes2'
  | 'notesHeader'
  | 'button'

interface TextProps {
  type: TextType
  className?: string
}

export const styles = {
  body1: cx(
    'text-sans',
    'text-base',
    'font-medium',
    'tracking-wide',
    'leading-body',
    'text-rodeo-grey/96',
    'opacity-96'
  ),
  body2: cx(
    'text-sans',
    'text-base',
    'font-bold',
    'tracking-wide',
    'leading-body',
    'text-rodeo-grey/96',
    'opacity-96'
  ),
  body3: cx(
    'text-sans',
    'text-base',
    'font-black',
    'tracking-wide',
    'leading-body',
    'text-rodeo-grey/96',
    'opacity-96'
  ),
  notes1: cx(
    'text-sans',
    'text-sm',
    'font-medium',
    'tracking-wide',
    'leading-notes',
    'text-rodeo-grey/96',
    'opacity-96'
  ),
  notes2: cx(
    'text-sans',
    'text-sm',
    'font-bold',
    'tracking-wide',
    'leading-notes',
    'text-rodeo-grey/96',
    'opacity-96'
  ),
  notesHeader: cx(
    'text-sans',
    'text-sm',
    'font-bold',
    'tracking-wide',
    'leading-notes',
    'text-rodeo-secondary1'
  ),
  button: cx(
    'text-sans',
    'text-sm',
    'font-black',
    'leading-button',
    'tracking-widest',
    'text-white'
  ),
}

export const Paragraph: FC<TextProps> = ({ type, className, children }) => (
  <p className={cx(styles[type], className)}>{children}</p>
)

export const Span: FC<TextProps> = ({ type, className, children }) => (
  <span className={cx(styles[type], className)}>{children}</span>
)
